var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"activityPage "},[_c('common-header'),_vm._v(" "),_c('list-kv',{attrs:{"kvArray":_vm.kvItems}}),_vm._v(" "),_c('activity',{attrs:{"tabArr":_vm.activityTabArr,"activityAllArr":_vm.activityArr}}),_vm._v(" "),_c('common-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a707a90","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/container/activityPage/activity.vue
// module id = null
// module chunks = 